(function () {
  'use strict';

  var modalSelector = '[data-country-modal]';
  var preferenceKey = 'naayas_selected_country_v1';
  var sessionKey = 'naayas-country-dismissed-v1';
  var syncKey = 'naayas-country-sync-v1';
  var returnFocus = null;
  var openingFromDrawer = false;
  var submitting = false;

  function modal() { return document.querySelector(modalSelector); }
  function picker(root) { return root.querySelector('[data-country-picker]'); }
  function field(root) { return root.querySelector('[data-country-field]'); }
  function options(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-country-option]')); }
  function visibleOptions(root) { return options(root).filter(function (option) { return !option.parentElement.hidden; }); }

  function rememberDismissal() {
    try { sessionStorage.setItem(sessionKey, '1'); } catch (error) { /* Storage can be unavailable. */ }
  }

  function clearDismissal() {
    try { sessionStorage.removeItem(sessionKey); } catch (error) { /* Storage can be unavailable. */ }
  }

  function sessionValue(key) {
    try { return sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function clearSync() {
    try { sessionStorage.removeItem(syncKey); } catch (error) { /* Storage can be unavailable. */ }
  }

  function markSync(code, activeCountry) {
    try {
      sessionStorage.setItem(syncKey, code + ':' + activeCountry);
      return true;
    } catch (error) { return false; }
  }

  function readPreference(root) {
    var raw;
    try { raw = localStorage.getItem(preferenceKey); }
    catch (error) { return { available: false, code: null, invalid: false }; }
    if (raw === null) return { available: true, code: null, invalid: false };

    var saved;
    try { saved = JSON.parse(raw); } catch (error) { saved = null; }
    var valid = saved && saved.version === 1 && saved.confirmed === true &&
      typeof saved.countryCode === 'string' && /^[A-Z]{2}$/.test(saved.countryCode) &&
      options(root).some(function (option) { return option.dataset.code === saved.countryCode; });
    if (valid) return { available: true, code: saved.countryCode, invalid: false };
    try { localStorage.removeItem(preferenceKey); } catch (error) { /* Ignore storage errors. */ }
    clearSync();
    return { available: true, code: null, invalid: true };
  }

  function savePreference(code) {
    try {
      localStorage.setItem(preferenceKey, JSON.stringify({ countryCode: code, confirmed: true, version: 1 }));
    } catch (error) { /* Shopify localization still works when storage is blocked. */ }
  }

  function syncPreference(root, code) {
    var activeCountry = root.dataset.currentCountry;
    if (sessionValue(syncKey) === code + ':' + activeCountry || !markSync(code, activeCountry)) return false;
    root.querySelector('[data-country-code]').value = code;
    var form = root.querySelector('[data-country-form]');
    try {
      if (form.requestSubmit) form.requestSubmit();
      else form.querySelector('[data-country-confirm]').click();
      return true;
    } catch (error) {
      clearSync();
      return false;
    }
  }

  function detectCountry(root) {
    var route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (typeof window.fetch !== 'function' || typeof route !== 'string') return Promise.resolve(null);
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var url = route.replace(/\/?$/, '/') + 'browsing_context_suggestions.json?country%5Benabled%5D=true';

    return new Promise(function (resolve) {
      var settled = false;
      var timeout = window.setTimeout(function () {
        if (controller) controller.abort();
        finish(null);
      }, 1000);

      function finish(option) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(option);
      }

      Promise.resolve().then(function () {
        return window.fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined });
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Country detection unavailable');
          return response.json();
        })
        .then(function (data) {
          var detected = data && data.detected_values && data.detected_values.country;
          var code = detected && detected.handle;
          var option = typeof code === 'string' && /^[A-Z]{2}$/.test(code)
            ? options(root).find(function (candidate) { return candidate.dataset.code === code; })
            : null;
          finish(option || null);
        }).catch(function () { finish(null); });
    });
  }

  function closePicker(root) {
    picker(root).hidden = true;
    field(root).setAttribute('aria-expanded', 'false');
  }

  function filter(root) {
    var query = root.querySelector('[data-country-search]').value.trim().toLocaleLowerCase();
    var count = 0;
    options(root).forEach(function (option) {
      var match = (option.dataset.name + ' ' + option.dataset.code).toLocaleLowerCase().includes(query);
      option.parentElement.hidden = !match;
      if (match) count++;
    });
    root.querySelector('[data-country-empty]').hidden = count !== 0;
  }

  function openPicker(root) {
    picker(root).hidden = false;
    field(root).setAttribute('aria-expanded', 'true');
    var search = root.querySelector('[data-country-search]');
    search.value = '';
    filter(root);
    search.focus();
  }

  function selectCountry(root, option) {
    root.querySelector('[data-country-code]').value = option.dataset.code;
    root.querySelector('[data-country-selected]').textContent = option.dataset.name;
    var selectedFlag = field(root).querySelector('[data-country-selected-flag]');
    var optionFlag = option.querySelector('.custom-country__flag');
    if (selectedFlag && optionFlag) {
      var chosenFlag = optionFlag.cloneNode(true);
      chosenFlag.removeAttribute('loading');
      while (selectedFlag.firstChild) selectedFlag.removeChild(selectedFlag.firstChild);
      selectedFlag.appendChild(chosenFlag);
    }
    options(root).forEach(function (candidate) {
      candidate.setAttribute('aria-selected', String(candidate === option));
    });
  }

  function choose(root, option) {
    if (!option || option.parentElement.hidden) return;
    selectCountry(root, option);
    closePicker(root);
    field(root).focus();
  }

  function show(trigger) {
    var root = modal();
    if (!root || !root.hidden) return;
    returnFocus = trigger;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    submitting = false;
    root.hidden = false;
    document.documentElement.classList.add('custom-country-open');
    var drawerWasOpen = document.documentElement.classList.contains('js-drawer-open');
    document.dispatchEvent(new CustomEvent('modalOpen'));
    if (drawerWasOpen) {
      window.setTimeout(function () { if (!root.hidden) root.querySelector('.custom-country__dialog').focus(); }, 520);
    } else {
      root.querySelector('.custom-country__dialog').focus();
    }
  }

  function open(trigger) {
    var drawer = trigger && trigger.closest('#NavDrawer');
    if (drawer && window.theme && theme.NavDrawer && theme.NavDrawer.isOpen) {
      if (openingFromDrawer) return;
      openingFromDrawer = true;
      theme.NavDrawer.close();
      window.setTimeout(function () {
        openingFromDrawer = false;
        show(trigger);
      }, 520);
      return;
    }
    show(trigger);
  }

  function close(remember) {
    var root = modal();
    if (!root || root.hidden) return;
    closePicker(root);
    root.hidden = true;
    document.documentElement.classList.remove('custom-country-open');
    if (remember !== false) rememberDismissal();
    var target = returnFocus;
    if (target && target.isConnected) target.setAttribute('aria-expanded', 'false');
    if (!target || !target.isConnected || !target.getClientRects().length) {
      target = Array.prototype.slice.call(document.querySelectorAll('.js-drawer-open-nav, [data-country-open]')).find(function (item) {
        return item.getClientRects().length > 0;
      });
    }
    if (target) target.focus();
    returnFocus = null;
  }

  function moveOption(root, current, direction) {
    var list = visibleOptions(root);
    if (!list.length) return;
    var index = list.indexOf(current);
    if (index < 0) index = direction > 0 ? -1 : 0;
    index = (index + direction + list.length) % list.length;
    list[index].focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-country-open]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    var root = modal();
    if (!root || root.hidden) return;
    if (event.target.closest('[data-country-close]')) { close(); return; }
    if (event.target.closest('[data-country-field]')) {
      if (picker(root).hidden) openPicker(root);
      else { closePicker(root); field(root).focus(); }
      return;
    }
    var option = event.target.closest('[data-country-option]');
    if (option && root.contains(option)) choose(root, option);
  });

  document.addEventListener('input', function (event) {
    var root = modal();
    if (root && !root.hidden && event.target.matches('[data-country-search]')) filter(root);
  });

  document.addEventListener('keydown', function (event) {
    var root = modal();
    if (!root || root.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      if (!picker(root).hidden) { closePicker(root); field(root).focus(); }
      else close();
      return;
    }
    var active = document.activeElement;
    if (!picker(root).hidden && (active.matches('[data-country-search]') || active.matches('[data-country-option]'))) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        moveOption(root, active, event.key === 'ArrowDown' ? 1 : -1);
        return;
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        choose(root, active.matches('[data-country-option]') ? active : visibleOptions(root)[0]);
        return;
      }
    }
    if (event.key === 'Tab') {
      var focusable = Array.prototype.slice.call(root.querySelectorAll('button, input')).filter(function (item) {
        return !item.disabled && item.getClientRects().length;
      });
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (active === first || active === root.querySelector('.custom-country__dialog'))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && active === last) { event.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-country-form]');
    if (!form) return;
    var root = modal();
    var code = form.querySelector('[data-country-code]').value;
    if (submitting || !options(root).some(function (option) { return option.dataset.code === code; })) {
      event.preventDefault();
      return;
    }
    savePreference(code);
    clearDismissal();
    if (code === root.dataset.currentCountry) {
      event.preventDefault();
      clearSync();
      close(false);
      return;
    }
    markSync(code, root.dataset.currentCountry);
    submitting = true;
    form.querySelector('[data-country-confirm]').disabled = true;
    form.setAttribute('aria-busy', 'true');
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector(modalSelector)) document.documentElement.classList.remove('custom-country-open');
  });

  function init() {
    var root = modal();
    if (!root) return;
    var preference = readPreference(root);
    if (!preference.available) return;
    if (preference.code === root.dataset.currentCountry) {
      clearSync();
      return;
    }
    if (preference.code && syncPreference(root, preference.code)) return;
    if (!preference.invalid && !preference.code && sessionValue(sessionKey) === '1') return;
    if (preference.code) {
      var savedOption = options(root).find(function (option) { return option.dataset.code === preference.code; });
      if (savedOption) selectCountry(root, savedOption);
    }
    var detection = preference.code ? Promise.resolve(null) : detectCountry(root);
    detection.then(function (detectedOption) {
      var latest = readPreference(root);
      if (modal() !== root || !root.hidden || !latest.available || latest.code === root.dataset.currentCountry ||
          (!latest.invalid && !latest.code && sessionValue(sessionKey) === '1')) return;
      if (detectedOption && !latest.code) {
        selectCountry(root, detectedOption);
        root.querySelector('#CustomCountryTitle').textContent = 'Are you shopping from ' + detectedOption.dataset.name + '?';
      }
      show(null);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
